import React from 'react';
import moment from 'moment';
import { getNumberFormat, colorCategory } from 'utils/helpers';
import CategoryIcons from 'library/categoryIcons';
import NoDataMsg from 'library/noData';

import { getDollarFormat } from 'utils/helpers';


const Body = ({ reorder, selectedDate, history }) => (
    <div>
        {
            reorder && reorder.list && reorder.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="text-center list_header">
                        {selectedDate ?
                            <p><i>Selected Date</i> <b>{moment(selectedDate).format('MMMM Do, YYYY')}</b></p>
                            : ""}
                    </div>
                    <div className="table-responsive">
                        {reorder.list &&
                            reorder.list.map((item, index) => {
                                return (
                                    <div className="mb-2">
                                        <div className="row m-0 mb-0 ">
                                            <div className="col-lg-2 col-md-3 border-right reorder-table-title">
                                                <label>Product Name</label>
                                                <h5 className="m-0">{item.pname}</h5>
                                                <br/>
                                                <h6 className="m-0">Brand: {item.brand}</h6>
                                                <h6 className="m-0">Category: {item.category}</h6>
                                                <h6 className="m-0">Species: {item.species}</h6>
                                                <h6 className="m-0">SKU: {item.sku}</h6>
                                            </div> {/* Column Orders */}
                                            <div className="row col-lg-3 col-md-8 daily_cash border-right pt-1">
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Sold Last Period</label>
                                                    <h5 className="m-0">{item.soldLastPeriod}</h5>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Value Sold</label>
                                                    <h5 className="m-0">{getDollarFormat(item.valueSold)}</h5>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Profit Margin</label>
                                                    <h5 className="m-0">{item.profitMargin != 0 ? Math.round(100 * (item.profitMargin * 10) / 10) + "%" : "-"}</h5>
                                                </div>
                                            </div>
                                            <div className="row col-lg-4 col-md-8 daily_cash border-right pt-1"> 
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Current Inventory (Store/Storage only)</label>
                                                    <h3 className="m-0">{item.currentInventoryStoreStorage}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                    {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                    <label>Estimated Inventory Next Week</label>
                                                    <h3 className="m-0">{item.estimatedInventoryNextWeek}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                    {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                    <label>Estimated Weeks Remaining until Stock-out</label>
                                                    <h3 className="m-0">{item.weeksRemainingUntilStockout != -1? item.weeksRemainingUntilStockout : "-" }</h3>
                                                </div>
                                            </div>
                                            <div className="row col-lg-3 col-md-8 daily_cash border-right pt-1">
                                                <div className="col-lg-6 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Restock cap</label>
                                                    <h3 className="m-0">{item.restockCap}</h3>
                                                </div>
                                                <div className="col-lg-6 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                    {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                    <label>Estimated Order quantity</label>
                                                    <h3 className="m-0">{item.recommendedReorderQuantity}</h3>
                                                </div>
                                            </div>
                                        </div>
                                        {history && <div className="row m-0 mt-0 text-center daily_cash border-right" style={{ borderStyle: 'Solid', borderBottomWidth: '1px', borderTopWidth: '0px', borderLeftmWidth: '0px', borderRightWidth: '0px' }}>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6 col-md- m-0 p-0">
                                                    <label>First Order Date</label>
                                                    <h3 className="m-0 grey-text">{moment(item.firstorderdate).format('YYYY/MM/DD')}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-4 col-md- m-0 p-0">
                                                    <label>Days in stock</label>
                                                    <h3 className="m-0 grey-text">{item.daysInStock}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-4 col-md- m-0 p-0">
                                                    <label>Total Sold</label>
                                                    <h3 className="m-0 grey-text">{item.totalsold}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-4 col-md- m-0 p-0">
                                                    <label>Average sales per day</label>
                                                    <h3 className="m-0 grey-text">{Math.round(item.velocity * 10) / 10}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-4 col-md- m-0 p-0">
                                                    <label>Days to sell 10 units</label>
                                                    <h3 className="m-0 grey-text">{Math.round(item.timeToSellTen * 10) / 10}</h3>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                );
                            }
                            )
                        }
                    </div>
                </div>
        }
    </div>
);
export default Body;